"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./CardShellRow.scss");
var CardShellRow = function (_a) {
    var children = _a.children, className = _a.className, testId = _a.testId, withMobileBleed = _a.withMobileBleed;
    var renderChildren = function () { return React.Children.map(children, function (child) { return child; }); };
    return (React.createElement("div", { className: "row flex-wrap flex-items-stretch pad-b-xs pad-t-xs" + (withMobileBleed ? " no-hpad-sm" : "") + " " + styles.cardPanel + (className ? " " + className : ""), "data-testid": testId }, renderChildren()));
};
exports.default = CardShellRow;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/CardShellRow/CardShellRow.js
// module id = 1756
// module chunks = 8